import { Dispatch } from "react";
import { useDispatch } from "react-redux";

export const useAppDispatch = () => useDispatch() as Dispatch<any>;
